import adonis from '../db_svg/adonis.svg'
import aspnet from '../db_svg/aspnet.svg'
import csharp from '../db_svg/csharp.svg'
import docker from '../db_svg/docker.svg'
import express from '../db_svg/express.svg'
import firebase from '../db_svg/firebase.svg'
import gcp from '../db_svg/gcp.svg'
import git from '../db_svg/git.svg'
import html from '../db_svg/html.svg'
import jest from '../db_svg/jest.svg'
import js from '../db_svg/js.svg'
import mysql from '../db_svg/mysql.svg'
import nest from '../db_svg/nest.svg'
import node from '../db_svg/node.svg'
import postgresql from '../db_svg/postgres.svg'
import prisma from '../db_svg/prisma.svg'
import python from '../db_svg/python.svg'
import reactLogo from '../db_svg/react.svg'
import redis from '../db_svg/redis.svg'
import rmq from '../db_svg/rabbitmq.svg'
import sequelize from '../db_svg/sequelize.svg'
import ts from '../db_svg/ts.svg'
import typeorm from '../db_svg/typeorm.svg'
import vueLogo from '../db_svg/vue.svg'

/** Ordem: backend → banco de dados / ORMs → front-end */
const TecnologiasProjects = [
  // —— Backend ——
  { name: 'Git', image: `${git}` },
  { name: 'JavaScript', image: `${js}` },
  { name: 'TypeScript', image: `${ts}` },
  { name: 'NodeJs', image: `${node}` },
  { name: 'NestJs', image: `${nest}` },
  { name: 'ExpressJS', image: `${express}` },
  { name: 'AdonisJs', image: `${adonis}` },
  { name: 'Python', image: `${python}` },
  { name: 'C#', image: `${csharp}` },
  { name: 'ASP.NET Core', image: `${aspnet}` },
  { name: 'RabbitMQ', image: `${rmq}` },
  { name: 'Jest/SuperTest', image: `${jest}` },
  { name: 'Docker', image: `${docker}` },
  { name: 'Google Cloud', image: `${gcp}` },
  { name: 'Firebase', image: `${firebase}` },
  // —— Banco de dados / ORMs ——
  { name: 'MySQL', image: `${mysql}` },
  { name: 'PostgreSQL', image: `${postgresql}` },
  { name: 'Redis', image: `${redis}` },
  { name: 'TypeORM', image: `${typeorm}` },
  { name: 'Prisma', image: `${prisma}` },
  { name: 'Sequelize', image: `${sequelize}` },
  // —— Front-end ——
  { name: 'Vue.js', image: `${vueLogo}` },
  { name: 'React.js', image: `${reactLogo}` },
  { name: 'HTML', image: `${html}` },
]

export default TecnologiasProjects
